import React from "react";

import { Box, Typography } from "@mui/material";

import { ModernFormField } from "../../../../common/ModernForm";

interface InputPromptProps {
  prompt: string;
  setPrompt: (prompt: string) => void;
  generateCustomShortFormVideoIdeasMutation: any;
}

export function InputPrompt({
  prompt,
  setPrompt,
  generateCustomShortFormVideoIdeasMutation,
}: InputPromptProps) {
  return (
    <Box>
      <Typography
        variant="body1"
        sx={{ mb: 3, color: "#6b7280", lineHeight: 1.6 }}
      >
        Describe the type of short video you want to generate from this episode:
      </Typography>
      <ModernFormField
        label="Video Description"
        name="prompt"
        multiline
        rows={3}
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="e.g., Create a highlight reel of the most engaging moments, focus on key insights about marketing, or generate a short video from 8:00 to 8:28..."
      />
      {generateCustomShortFormVideoIdeasMutation?.isPending && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, fontStyle: "italic" }}
        >
          🎬 Analyzing your episode and generating creative video ideas...
        </Typography>
      )}
    </Box>
  );
}
